import { __extends } from "tslib";
import { PutBucketVersioningRequest } from "../models/models_0";
import { deserializeAws_restXmlPutBucketVersioningCommand, serializeAws_restXmlPutBucketVersioningCommand, } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutBucketVersioningCommand = /** @class */ (function (_super) {
    __extends(PutBucketVersioningCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutBucketVersioningCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutBucketVersioningCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "S3Client";
        var commandName = "PutBucketVersioningCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: PutBucketVersioningRequest.filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutBucketVersioningCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutBucketVersioningCommand(input, context);
    };
    PutBucketVersioningCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutBucketVersioningCommand(output, context);
    };
    return PutBucketVersioningCommand;
}($Command));
export { PutBucketVersioningCommand };
//# sourceMappingURL=PutBucketVersioningCommand.js.map